export default {
  callBySlug: (slug, parameters) => 
    import('../../services/lambdaService').then(service => 
      service.default.callBySlug(slug, parameters)
    ),
  
  callLambda: (url, method, queryParams, body, customHeaders) => 
    import('../../services/lambdaService').then(service => 
      service.default.callLambda(url, method, queryParams, body, customHeaders)
    ),

  // Specific convenience methods
  getTargetCustomerNames: (inputText) => 
    import('../../services/lambdaService').then(service => 
      service.default.getTargetCustomerNames(inputText)
    ),
  getTargetCustomerDemographics: (targetCustomer) => 
    import('../../services/lambdaService').then(service => 
      service.default.getTargetCustomerDemographics(targetCustomer)
    ),
  getTargetCustomerMarket: (targetCustomer) => 
    import('../../services/lambdaService').then(service => 
      service.default.getTargetCustomerMarket(targetCustomer)
    ),
  getTargetCustomerOutreachAreas: (targetCustomer) => 
    import('../../services/lambdaService').then(service => 
      service.default.getTargetCustomerOutreachAreas(targetCustomer)
    ),
  getOpportunityMapping: (targetCustomer, action) => 
    import('../../services/lambdaService').then(service => 
      service.default.getOpportunityMapping(targetCustomer, action)
    ),
  getContactList: (platform, targetUrl, targetCustomer) => 
    import('../../services/lambdaService').then(service => 
      service.default.getContactList(platform, targetUrl, targetCustomer)
    ),
  getTranscriptAnalysis: (transcript, researchPrompt) => 
    import('../../services/lambdaService').then(service => 
      service.default.getTranscriptAnalysis(transcript, researchPrompt)
    ),
  getSurveyLanguage: (surveyLanguage) => 
    import('../../services/lambdaService').then(service => 
      service.default.getSurveyLanguage(surveyLanguage)
    )
};
